import React, { useMemo } from 'react'
import { Card, CardContent, CardHeader, ToggleButton, ToggleButtonGroup } from '@mui/material'
import BarChartIcon from '@mui/icons-material/BarChart'
import TableChartIcon from '@mui/icons-material/TableChart'
import { HorizontalStackedBarChart } from '../../../charts/BarChart'
import getColor from '../../../charts/colors'
import ZoneDayWiseAttemptTable from './ZoneDayWiseAttemptTable'

const ZoneWiseAttemptAgeingKeys = [
    'atZeroDay', 'atOneDay', 'atTwoDay', 'atThreeDay',
    'atFourDay', 'atFiveDay', 'atSixDay', 'atSevenAndMoreDay'
]

export default function FirstDeliveryAttemptAgeing({ data, title, subtitle, labelPrefix = 'P2A', alert = null }) {
    const [view, setView] = React.useState('chart')

    const chartOptions = useMemo(
        () => ({
            yaxis: 'name',
            yLabel: 'Zone',
            xLabel: '% Shipments',
            stackId: 'stackId',
            domain: [0, 101],
            useSimpleTooltip: true,
            data: ZoneWiseAttemptAgeingKeys.map((key, i) => ({
                dataKey: `${key}Percentage`,
                label: `${i} Day${i <= 1 ? '' : 's'}`,
                unit: '%',
                fill: getColor(i + 19),
            })),
        }),
        []
    )

    return (
        <Card elevation={1}>
            <CardHeader
                title={title}
                subheader={subtitle}
                action={
                    <ToggleButtonGroup
                        color='primary'
                        size='small'
                        exclusive
                        onChange={(_e, v) => setView(v)}
                        value={view}
                    >
                        <ToggleButton value='chart'>
                            <BarChartIcon fontSize='small' />
                        </ToggleButton>
                        <ToggleButton value='table'>
                            <TableChartIcon fontSize='small' />
                        </ToggleButton>
                    </ToggleButtonGroup>
                }
            />
            {alert}
            <CardContent>
                {view === 'chart' && (
                    <HorizontalStackedBarChart data={data} chartOptions={chartOptions} height={500} />
                )}
                {view === 'table' && <ZoneDayWiseAttemptTable data={data} labelPrefix={labelPrefix} />}
            </CardContent>
        </Card>
    )
}
